import React from "react";
import { Icon } from "components/shared/icon/Icon";

interface TextInputProps {
  iconId: string;
  type: string;
  id: string;
  placeholder?: string;
  value: string | number | string[] | undefined;
  error?: string;
  autocomplete?: string;
  horizontal?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const TextInput: React.FC<TextInputProps> = ({
  type,
  iconId,
  id,
  placeholder,
  value,
  error,
  autocomplete,
  onChange,
}: TextInputProps) => {
  return (
    <>
      <div className="input-group mb-3">
        <div className="input-group-prepend">
          <label htmlFor={id}>
            <span className="input-group-text" id={"icon"}>
              <Icon id={iconId} />
            </span>
          </label>
        </div>
        <input
          type={type}
          className="form-control"
          id={id}
          placeholder={placeholder}
          value={value || ""}
          onChange={onChange}
          autoComplete={autocomplete}
        />
        <small
          id={`${id}-help`}
          aria-describedby={id}
          className="form-text text-danger"
        >
          {error}
        </small>
      </div>
    </>
  );
};
